import axios from "axios";
import { URL } from "../Home/api";

export const fetchProductById = async (id) => {
  const response = await axios.get(`${URL}api/catalog/${id}`);
  return response.data;
};
